'use strict';

define(['app'], function (app) {
  var createEvent = function createEvent(name) {
    try {
      return new Event(name);
    } catch (e) {
      var event = document.createEvent('Event');
      event.initEvent(name, false, false);
      return event;
    }
  };
  var findHiddenForRadio = function findHiddenForRadio(root, radio) {
    var variationId = radio.getAttribute('data-variation-id');
    return root.querySelector('input[type="hidden"][data-variation-id="' + variationId + '"]');
  };

  var athenaProductVariations = function athenaProductVariations() {
    var self = this;

    var _config = {
      variationOptions: {
        selector: '[data-dropdown=productVariation]',
        containerSelector: '[data-variation-container=athenaProductVariations]',
        radioSelector: '[data-radio]',
        variationId: 'data-variation-id',
        masterProductId: 'data-master-id',
        childProductId: 'data-child-id',
        currentQuantityInBasket: 'data-information-current-quantity-basket',
        maximumAllowedQuantityInBasket: 'data-information-maximum-allowed-quantity',
        informationUrl: 'data-information-url'
      },
      colorSwatches: {
        selector: '[data-color-swatch]',
        dataSelected: 'data-selected',
        selectedClassLight: 'athenaProductVariations_colorSwatch-selected-light',
        selectedClassDark: 'athenaProductVariations_colorSwatch-selected-dark',
        borderedClass: 'athenaProductVariations_colorSwatch-bordered',
        dataValueId: 'data-value-id',
        dataDisabled: 'data-disabled',
        colorHexSumThreshold: 48
      },
      colorDropdown: {
        selector: '[data-dropdown-type=color]'
      },
      subscribeChannels: {
        variations: 'productVariations/variationData',
        image: 'productSingleImage/newImage',
        imageMultiple: 'productMultipleImages/newImage',
        price: 'productPrice/newPrice',
        icons: 'productNutritionalIcons/newIcons',
        stock: 'productStockInformation/newStockInformation',
        releaseDate: 'productReleaseDate/newReleaseDate',
        addToBasketButton: 'productAddToBasketButton/newButton',
        moreInformation: 'productViewMoreInformation/newUrl',
        information: 'productInformation/newInformation',
        description: 'productDescription/newDescription',
        productQuantityInput: 'productQuantity/productQuantity'
      }
    };

    var _init = function _init(element) {
      self.element = element;
      self.app = app;

      self.innerContainer = self.element.querySelector(self.config.variationOptions.containerSelector);
      self.childProductId = self.innerContainer.getAttribute(self.config.variationOptions.childProductId);
      self.informationUrl = self.innerContainer.getAttribute(self.config.variationOptions.informationUrl);
      self.masterProductId = self.element.getAttribute(self.config.variationOptions.masterProductId);
      self.colorSwatches = self.element.querySelectorAll(self.config.colorSwatches.selector);
      self.colorDropdown = self.element.querySelector(self.config.colorDropdown.selector);
      self.variationOptions = self.element.querySelectorAll(self.config.variationOptions.selector);
      self.radios = self.element.querySelectorAll(self.config.variationOptions.radioSelector);
      self.backgroundColor = window.getComputedStyle(self.element).getPropertyValue('background-color');
      self.quantityInputData = {
        numberOfItemsInBasket: self.innerContainer.getAttribute(self.config.variationOptions.currentQuantityInBasket),
        maximumNumberOfItemsToAdd: self.innerContainer.getAttribute(self.config.variationOptions.maximumAllowedQuantityInBasket)
      };

      self.radioOnLoad();
      self.addEventListeners();
      self.updateVariationData();
      self.changeProductInformation();

      if (self.quantityInputData.numberOfItemsInBasket !== null && self.quantityInputData.numberOfItemsInBasket !== '0' && self.quantityInputData.numberOfItemsInBasket !== 0 && !isNaN(self.quantityInputData.numberOfItemsInBasket)) {
        if (self.quantityInputData.maximumNumberOfItemsToAdd !== null && self.quantityInputData.maximumNumberOfItemsToAdd !== '0' && self.quantityInputData.maximumNumberOfItemsToAdd !== 0 && !isNaN(self.quantityInputData.maximumNumberOfItemsToAdd)) {
          app.publish(self.config.subscribeChannels.productQuantityInput, self.quantityInputData, true);
        }
      }
      return self;
    };

    var _addEventListeners = function _addEventListeners() {
      if (self.colorDropdown) {
        self.colorDropdown.addEventListener('change', self.changeColorDropdown);
        self.selectSwatchOnLoad(self.colorDropdown.value);
      }

      for (var i = 0, l = self.colorSwatches.length; i < l; i++) {

        var thisColorSwatch = self.colorSwatches[i];
        var thisDisabled = thisColorSwatch.getAttribute(self.config.colorSwatches.dataDisabled) !== null;

        if (!thisDisabled) {
          thisColorSwatch.addEventListener('click', self.clickColorSwatch);
        }

        if (self.colorIsSameAsBg(thisColorSwatch)) {
          self.addBorderToColorSwatch(thisColorSwatch);
        }
      }

      for (i = 0, l = self.variationOptions.length; i < l; i++) {
        self.variationOptions[i].addEventListener('change', self.variationsChange);
      }

      for (i = 0; i < self.radios.length; i++) {
        var radio = self.radios[i];
        radio.addEventListener('change', self.radioChange.bind(null, radio));
      }
    };

    var _variationsChange = function _variationsChange() {
      app.ajax.post({
        url: '/' + self.masterProductId + '.variations?stringTemplatePath=components/athenaProductVariations/athenaProductVariations',
        send: JSON.stringify(self.constructPostData()),
        requestHeader: {
          header: 'Content-Type',
          value: 'application/json'
        },
        success: self.variationSuccessHandler,
        error: self.variationErrorHandler
      });
    };

    var _radioOnLoad = function _radioOnLoad() {
      [].filter.call(self.radios, function (radio) {
        return radio.checked;
      }).forEach(function (checkedRadio) {
        findHiddenForRadio(self.element, checkedRadio).value = checkedRadio.value;
      });
    };

    var _radioChange = function _radioChange(radio) {
      if (!radio.checked) return;
      var hiddenInput = findHiddenForRadio(self.element, radio);
      hiddenInput.value = radio.value;
      hiddenInput.dispatchEvent(createEvent('change'));
    };

    var _constructPostData = function _constructPostData() {
      var postData = {
        selected: 0
      };

      for (var i = 0, l = self.variationOptions.length; i < l; i++) {
        var input = self.variationOptions[i];
        postData['variation' + (i + 1)] = input.getAttribute(self.config.variationOptions.variationId);
        postData['option' + (i + 1)] = input.value;
        if (input.value) postData.selected++;
      }

      return postData;
    };

    var _variationSuccessHandler = function _variationSuccessHandler(response) {
      self.updateChildId(response);
      self.updateVariationData(response);
      self.changeProductImage();
      self.changeProductPrice();
      self.changeProductStockInformation();
      self.changeReleaseDate();
      self.changeAddToBasketButton();
      self.changeProductIcons();
      self.changeProductViewMoreInformation();
      self.changeProductInformation();
      self.changeProductDescription();
    };

    var _variationErrorHandler = function _variationErrorHandler() {
      console.error('ERROR: Could not retrieve variation data for product: ' + self.masterProductId);
    };

    var _updateChildId = function _updateChildId(response) {
      var newContainer = document.createElement('html');
      newContainer.innerHTML = response;
      var newElem = newContainer.querySelector(self.config.variationOptions.containerSelector);
      var oldElem = self.element.querySelector(self.config.variationOptions.containerSelector);
      self.element.removeChild(oldElem);
      self.element.appendChild(newElem);
      self.init(newElem.parentElement);

      app.publish(self.config.subscribeChannels.productQuantityInput, self.quantityInputData, true);
    };

    var _updateVariationData = function _updateVariationData() {
      var variationData = {
        variationLength: self.variationOptions.length,
        variations: []
      };

      for (var i = 0; i < self.variationOptions.length; i++) {
        var thisVariationDropdown = self.variationOptions[i];
        if (!thisVariationDropdown.value) continue;
        variationData.variations.push(thisVariationDropdown.value);
      }

      app.publish(self.config.subscribeChannels.variations, variationData, true);
    };

    var _changeProductImage = function _changeProductImage() {
      app.publish(self.config.subscribeChannels.image, self.childProductId, true);
      app.publish(self.config.subscribeChannels.imageMultiple, {
        productId: self.childProductId,
        variation: false
      });
    };

    var _changeProductPrice = function _changeProductPrice() {
      app.publish(self.config.subscribeChannels.price, self.childProductId, true);
    };

    var _changeProductStockInformation = function _changeProductStockInformation() {
      app.publish(self.config.subscribeChannels.stock, self.childProductId, true);
    };

    var _changeReleaseDate = function _changeReleaseDate() {
      app.publish(self.config.subscribeChannels.releaseDate, self.childProductId, true);
    };

    var _changeAddToBasketButton = function _changeAddToBasketButton() {
      app.publish(self.config.subscribeChannels.addToBasketButton, self.childProductId, true);
    };

    var _changeProductIcons = function _changeProductIcons() {
      app.publish(self.config.subscribeChannels.icons, self.childProductId, true);
    };

    var _changeProductViewMoreInformation = function _changeProductViewMoreInformation() {
      app.publish(self.config.subscribeChannels.moreInformation, self.informationUrl, true);
    };

    var _changeProductInformation = function _changeProductInformation() {
      app.publish(self.config.subscribeChannels.information, self.childProductId, true);
    };

    var _changeProductDescription = function _changeProductDescription() {
      app.publish(self.config.subscribeChannels.description, self.childProductId, true);
    };

    var _colorIsSameAsBg = function _colorIsSameAsBg(colorSwatch) {
      return self.backgroundColor === window.getComputedStyle(colorSwatch).getPropertyValue('background-color');
    };

    var _selectSwatchOnLoad = function _selectSwatchOnLoad(value) {
      if (value && value !== '') {
        self.updateColorSwatch(value);
      }
    };

    var _addBorderToColorSwatch = function _addBorderToColorSwatch(colorSwatch) {
      app.element.addClass(self.config.colorSwatches.borderedClass, colorSwatch);
    };

    var _deselectAllColorSwatches = function _deselectAllColorSwatches() {
      for (var i = 0, l = self.colorSwatches.length; i < l; i++) {
        var thisColorSwatch = self.colorSwatches[i];
        app.element.setAttribute(self.config.colorSwatches.dataSelected, 'false', thisColorSwatch);
        app.element.removeClass(self.config.colorSwatches.selectedClassLight, thisColorSwatch);
        app.element.removeClass(self.config.colorSwatches.selectedClassDark, thisColorSwatch);
      }
    };

    var _clickColorSwatch = function _clickColorSwatch() {
      self.deselectAllColorSwatches();
      self.selectColorSwatch(this);
      self.updateColorDropdown(app.element.getAttribute(self.config.colorSwatches.dataValueId, this));
      self.variationsChange(this);
    };

    var _changeColorDropdown = function _changeColorDropdown() {
      self.updateColorSwatch(this.value);
    };

    var _updateColorDropdown = function _updateColorDropdown(value) {
      self.colorDropdown.value = value;
    };

    var _selectColorSwatch = function _selectColorSwatch(color) {
      app.element.setAttribute(self.config.colorSwatches.dataSelected, 'true', color);

      var styleAttribute = color.getAttribute('style');
      var selectedSwatchColorHex = styleAttribute.split(': ')[1];
      if (self.getColorSum(selectedSwatchColorHex) <= self.config.colorSwatches.colorHexSumThreshold) {
        app.element.addClass(self.config.colorSwatches.selectedClassLight, color.parentElement);
      } else {
        app.element.addClass(self.config.colorSwatches.selectedClassDark, color.parentElement);
      }
    };

    var _getColorSum = function _getColorSum(color) {
      var colorArray = color.split('');
      var sumColorHex = 0;
      for (var i = 0; i < colorArray.length; i++) {
        if (colorArray[i] >= '0' && colorArray[i] <= '9') {
          sumColorHex += Number(colorArray[i]);
        } else if (colorArray[i] >= 'a' && colorArray[i] <= 'f') {
          sumColorHex += Number(colorArray[i].charCodeAt(0) - 'a'.charCodeAt(0) + 10);
        } else if (colorArray[i] >= 'A' && colorArray[i] <= 'F') {
          sumColorHex += Number(colorArray[i].charCodeAt(0) - 'A'.charCodeAt(0) + 10);
        }
      }
      return sumColorHex;
    };

    var _updateColorSwatch = function _updateColorSwatch(value) {
      self.deselectAllColorSwatches();

      for (var i = 0, l = self.colorSwatches.length; i < l; i++) {
        var thisColorSwatch = self.colorSwatches[i];
        if (app.element.getAttribute(self.config.colorSwatches.dataValueId, thisColorSwatch) === value) {
          self.selectColorSwatch(thisColorSwatch);
          return;
        }
      }
    };

    self.init = _init;
    self.config = _config;
    self.selectSwatchOnLoad = _selectSwatchOnLoad;
    self.variationsChange = _variationsChange;
    self.radioChange = _radioChange;
    self.radioOnLoad = _radioOnLoad;
    self.variationSuccessHandler = _variationSuccessHandler;
    self.variationErrorHandler = _variationErrorHandler;
    self.constructPostData = _constructPostData;
    self.updateChildId = _updateChildId;
    self.addEventListeners = _addEventListeners;
    self.updateVariationData = _updateVariationData;
    self.changeProductImage = _changeProductImage;
    self.changeProductPrice = _changeProductPrice;
    self.changeProductStockInformation = _changeProductStockInformation;
    self.changeReleaseDate = _changeReleaseDate;
    self.changeAddToBasketButton = _changeAddToBasketButton;
    self.changeProductIcons = _changeProductIcons;
    self.changeProductViewMoreInformation = _changeProductViewMoreInformation;
    self.changeProductInformation = _changeProductInformation;
    self.changeProductDescription = _changeProductDescription;
    self.clickColorSwatch = _clickColorSwatch;
    self.deselectAllColorSwatches = _deselectAllColorSwatches;
    self.getColorSum = _getColorSum;
    self.updateColorDropdown = _updateColorDropdown;
    self.changeColorDropdown = _changeColorDropdown;
    self.updateColorSwatch = _updateColorSwatch;
    self.selectColorSwatch = _selectColorSwatch;
    self.colorIsSameAsBg = _colorIsSameAsBg;
    self.addBorderToColorSwatch = _addBorderToColorSwatch;
  };

  return athenaProductVariations;
});
//# sourceMappingURL=athenaProductVariations.js.map
